const VersionInfo = {
	version: "1.24.17",
	major: 1,
	minor: 24,
	patch: 17,
	suffix: "",
	isNext: false,
	buildTime: 1741076161,
};
export default VersionInfo;